import { render, staticRenderFns } from "./ConfigurationListItem.vue?vue&type=template&id=bb9ea86c&scoped=true"
import script from "./ConfigurationListItem.vue?vue&type=script&lang=js"
export * from "./ConfigurationListItem.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationListItem.vue?vue&type=style&index=0&id=bb9ea86c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9ea86c",
  null
  
)

export default component.exports